module.exports = __webpack_public_path__ + "media/index/ww-art-01d7ecb5.png";